import { render, staticRenderFns } from "./day.vue?vue&type=template&id=05636576&scoped=true&"
import script from "./day.vue?vue&type=script&lang=js&"
export * from "./day.vue?vue&type=script&lang=js&"
import style0 from "./day.vue?vue&type=style&index=0&id=05636576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05636576",
  null
  
)

export default component.exports